import { Notification } from 'element-ui';

export const errorHandler = (errorInfo, options = { type: 'error' }) => {
  if (!errorInfo) return;
  if (typeof errorInfo === 'string') {
    return Promise.resolve().then(() => {
      setTimeout(() => {
        Notification({
          title: '客户端异常',
          message: errorInfo,
          type: 'warning',
        });
      });
    })  
    
  }

  let { type } = options;
  const { message, title, status } = errorInfo;
  if (/^4/g.test(status)) type = 'warning';


  return Promise.resolve().then(() => {
    Notification({
      title,
      message,
      type,
    });
  })
};

export default {};
